import { useAppSelector, useAppDispatch } from 'hooks';

import { Text } from '@chakra-ui/react';

import Card from 'components/card/Card';

import CheckBoxInput from 'components/fields/auto/CheckBoxInput';

import { changeBrokerAcknowledgement } from 'reducers/autoPersonalFormReducer';

import { SECTIONS } from 'views/auto_form/constants';

const Acknowledgement = () => {
  const dispatch = useAppDispatch();

  const hasBrokerAcknowledged = useAppSelector(
    (state) => state.autoPersonalForm.data.has_broker_acknowledged,
  );

  return (
    <Card mb="20px" id="sectionAcknowledgement">
      <Text fontWeight="bold" fontSize="xl" mb="10px">
        Acknowledgement
      </Text>

      <CheckBoxInput
        label="Acknowledgement"
        section={SECTIONS.AKNOWLEDGEMENT}
        isChecked={hasBrokerAcknowledged}
        onChange={(e) =>
          dispatch(changeBrokerAcknowledgement(e.target.checked))
        }
        required
      >
        To the best of my knowledge all of the information above is accurate.
      </CheckBoxInput>
    </Card>
  );
};

export default Acknowledgement;
